package ir.yusefpasha.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.components.style.toModifier
import ir.yusefpasha.models.Service
import ir.yusefpasha.models.Theme
import ir.yusefpasha.style.AboutTextStyle
import ir.yusefpasha.style.ServiceCardStyle
import ir.yusefpasha.util.Constants
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun ServiceCard(
    service: Service,
    breakpoint: Breakpoint
) {
    Column(
        modifier = ServiceCardStyle.toModifier()
            .margin(20.px)
            .padding(20.px)
            .maxWidth(300.px)
            .borderRadius(
                topRight = 10.px,
                topLeft = 10.px,
                bottomLeft = 10.px,
                bottomRight = 10.px
            )
    ) {
        Box(
            modifier = Modifier
                .id("iconBox")
                .margin(all = 10.px)
                .margin(bottom = 20.px)
                .padding(all = 10.px)
                .borderRadius(
                    topRight = 20.px,
                    topLeft = 20.px,
                    bottomLeft = 20.px,
                    bottomRight = 0.px
                )
                .border(
                    width = 2.px,
                    style = LineStyle.Solid,
                    color = Theme.Primary.rgb
                )
        ) {
            Image(
                modifier = Modifier.size(40.px),
                src = service.icon
            )
        }

        P(
            attrs = Modifier
                .fillMaxWidth()
                .margin(top = 0.px, bottom = 10.px)
                .fontFamily(Constants.FONT_FAMILY)
                .fontSize(if (breakpoint >= Breakpoint.LG) 20.px else 14.px)
                .fontWeight(FontWeight.Normal)
                .toAttrs()
        ) {
            Text(service.title)
        }

        P(
            attrs = Modifier
                .margin(top = 0.px, bottom = 0.px)
                .fontFamily(Constants.FONT_FAMILY)
                .fontSize(if (breakpoint >= Breakpoint.LG) 14.px else 10.px)
                .fontWeight(FontWeight.Normal)
                .toAttrs()
        ) {
            Text(service.description)
        }
    }
}